import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import LinearProgress from "@mui/material/LinearProgress";
import Chip from "@mui/material/Chip";

function BeastProgress({ jobData, isRunning }) {
  if (!jobData) {
    return (
      <MDBox textAlign="center" py={3}>
        <MDTypography variant="h6" color="text">
          正在建立任務...
        </MDTypography>
      </MDBox>
    );
  }

  const progress = (jobData.currentIter / jobData.maxIterate) * 100;
  const statusColor = {
    RUNNING: "info",
    SUCCEEDED: "success",
    BEST_EFFORT: "warning",
    FAILED: "error",
  }[jobData.status] || "primary";

  const statusText = {
    RUNNING: "執行中",
    SUCCEEDED: "成功完成",
    BEST_EFFORT: "已達最大迭代次數",
    FAILED: "執行失敗",
  }[jobData.status] || jobData.status;

  return (
    <MDBox mb={3}>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MDTypography variant="h6">
          任務進度
        </MDTypography>
        <Chip label={statusText} color={statusColor} />
      </MDBox>

      <MDBox mb={2}>
        <MDTypography variant="body2" color="text" mb={1}>
          迭代進度: {jobData.currentIter} / {jobData.maxIterate}
        </MDTypography>
        <LinearProgress variant="determinate" value={progress} color={statusColor} />
      </MDBox>

      {jobData.iterations && jobData.iterations.length > 0 && (
        <MDBox>
          <MDTypography variant="body2" color="text" mb={1}>
            最近迭代:
          </MDTypography>
          {jobData.iterations.slice(-3).reverse().map((iter) => (
            <MDBox key={iter.id} display="flex" justifyContent="space-between" py={1} px={2} mb={1} borderRadius="md" bgColor="grey-100">
              <MDTypography variant="caption">
                Iteration {iter.iterNo}
              </MDTypography>
              <MDTypography variant="caption" color={iter.status === "DONE" ? "success" : "error"}>
                {iter.status === "DONE" ? (
                  `✓ Return: ${iter.kpi?.returnRatePct?.toFixed(2)}%, MDD: ${iter.kpi?.maxDrawdownPct?.toFixed(2)}%, Trades: ${iter.kpi?.trades}`
                ) : (
                  `✗ ${iter.error || "Failed"}`
                )}
              </MDTypography>
            </MDBox>
          ))}
        </MDBox>
      )}
    </MDBox>
  );
}

export default BeastProgress;
